import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../../business/referential/UserContext';

function CopyrightWebResponse({ Callback }) {

    const [isResponseReady, setResponseReady] = useState(false);
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const [pageId, setPageId] = useState(32);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });

        }
        process();

    }, []);

    useEffect(() => {
        if (Callback) {
            setResponseReady(true);
        }
    }, [Callback]);

    return (
        <div className="dashboard-container dashboard-container__congratulation">
            <h3 className="mb-2">
                {getContent("CWR_TITLE")}
            </h3>
            <p className="mb-4 mb-md-5">{getContent("CWR_NOTE1")}</p>
            <p className="note">
                {getContent("CWR_SUBTITLE")}
            </p>
            {isResponseReady && <h6>
                Website#ID: {Callback.id}
            </h6>}
            <p className="note">
                {getContent("CWR_NOTE2")}
            </p>
            <p className="note">
                {getContent("CWR_NOTE3")}
            </p>
            <p className="note">
                {getContent("CWR_NOTE4")}
            </p>
            <div className="bg-gray p-4 mb-5">
                {isResponseReady && <a href={Callback.websiteName} target="_blank">
                    {Callback.websiteName}
                </a>}
            </div>
            <a href="/dashboard" className="btn btn-blue">
                {getContent("ReturnMenuLink")}
            </a>
            <a href="/dashboard" className="arrow-back"></a>
        </div>
    );
}

export default CopyrightWebResponse;